export default "__VITE_ASSET__CFeJFTSw__"